import Backbone from 'backbone';
import Model from './InterfaceLogModel';
import Globals from '../../../utils/Globals';

const Collection = Backbone.Collection.extend({
    url: () => Globals.baseUrl + 'interfaces/logs',
    model: Model,
});
export default Collection;
